import { REFORESTATION_URL, VISIT_URL } from '@app/links'
import { useI18n } from '@i18n/I18nProvider'
import { Icon, type IconName } from '@ui/Icon'
import { Screen } from '@ui/Screen'
import type { ReactNode } from 'react'
import { Link } from 'wouter'

const ROW = 'flex min-h-16 items-center gap-3 rounded-3xl bg-white p-4 shadow-sm active:bg-earth-100'

const RowContent = ({ icon, title, hint, end }: { icon: IconName; title: string; hint: string; end: ReactNode }) => (
	<>
		<span className="flex size-12 shrink-0 items-center justify-center rounded-full bg-sage-200 text-olive-900">
			<Icon name={icon} />
		</span>
		<span className="min-w-0 flex-1">
			<span className="block text-lg font-bold text-forest-800">{title}</span>
			<span className="block text-earth-800">{hint}</span>
		</span>
		{end}
	</>
)

// "Más": la galería de fotos, proponer un lugar mágico, las webs del Camino (se enlazan, no se duplican) y, al final, el
// acceso del personal al panel de seguimiento.
export const MorePage = () => {
	const { t } = useI18n()
	return (
		<Screen title={t('more.title')}>
			<Link href="/mas/galeria" className={ROW}>
				<RowContent
					icon="image"
					title={t('more.gallery')}
					hint={t('more.galleryHint')}
					end={<Icon name="forward" className="size-6 shrink-0 text-earth-600" />}
				/>
			</Link>
			<Link href="/lugar-magico?desde=mas" className={`${ROW} mt-3`}>
				<RowContent
					icon="sparkles"
					title={t('more.magic')}
					hint={t('more.magicHint')}
					end={<Icon name="forward" className="size-6 shrink-0 text-earth-600" />}
				/>
			</Link>

			<h2 className="mt-8 mb-3 text-2xl font-semibold">{t('more.webs')}</h2>
			<ul className="grid gap-3">
				{(
					[
						[VISIT_URL, 'globe', 'Visit Camino de la Vera Cruz', t('more.visitHint')],
						[REFORESTATION_URL, 'tree', 'Reforestación Camino Vera Cruz', t('more.reforestationHint')],
					] as const
				).map(([href, icon, title, hint]) => (
					<li key={href}>
						<a href={href} target="_blank" rel="noopener noreferrer" className={ROW}>
							<RowContent
								icon={icon}
								title={title}
								hint={hint}
								end={<Icon name="external" className="size-5 shrink-0 text-earth-600" />}
							/>
						</a>
					</li>
				))}
			</ul>

			<h2 className="mt-8 mb-3 text-2xl font-semibold">{t('more.association')}</h2>
			<Link href="/panel" className={ROW}>
				<RowContent
					icon="lock"
					title={t('more.panel')}
					hint={t('more.panelHint')}
					end={<Icon name="forward" className="size-6 shrink-0 text-earth-600" />}
				/>
			</Link>
		</Screen>
	)
}
